import { Badge, Button, Offcanvas } from 'react-bootstrap';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { MouseEvent } from 'react';
import { defaultClientsStatus, useClients } from '../context/ClientsProvider';
import { isSameIdSet } from 'utils/helpers/list/isSameIdSet';
import SolarIcon from 'components/icons/SolarIcon';
import EToolTip from 'components/others/EToolTip';

const clientStatuses = [0, 1];

const ClientFilterStatus = () => {
    const { t } = useTranslation(['Clients', 'common']);
    const { clientsStatus, setClientsStatus } = useClients();
    const [show, setShow] = useState(false);
    const [draftStatus, setDraftStatus] = useState<number[]>([...clientsStatus]);
    const filterActive = !isSameIdSet(clientsStatus, defaultClientsStatus);

    const handleHide = () => setShow(false);

    const handleOpen = () => {
        setDraftStatus([...clientsStatus]);
        setShow(true);
    };

    const handleClickStatus = (e: MouseEvent<HTMLElement>, statusID: number) => {
        e.currentTarget.blur();
        setDraftStatus((prev) =>
            prev.includes(statusID) ? prev.filter((id) => id !== statusID) : [...prev, statusID],
        );
    };

    const handleApply = () => {
        setClientsStatus([...draftStatus]);
        handleHide();
    };

    const handleReset = () => {
        setClientsStatus([...defaultClientsStatus]);
        handleHide();
    };

    return (
        <>
            <EToolTip title={t('toolFilterStatus')}>
                <span className="d-inline-block">
                    <Button
                        className="fs-14 px-2 ms-1"
                        size="sm"
                        variant={filterActive ? 'danger' : 'primary'}
                        onClick={(e) => {
                            e.currentTarget.blur();
                            handleOpen();
                        }}
                    >
                        <SolarIcon name="funnel" className="fs-14 p-0" />
                    </Button>
                </span>
            </EToolTip>

            <Offcanvas show={show} onHide={handleHide} placement="end">
                <Offcanvas.Header closeButton className="border-bottom">
                    <Offcanvas.Title>{t('toolFilterStatus')}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="position-relative pb-0 d-flex flex-column px-0">
                    <div className="off-filter-form d-flex flex-column h-100">
                        <div className="off-filter-content px-3">
                            {clientStatuses.map((statusID) => (
                                <button
                                    type="button"
                                    key={statusID}
                                    className="off-filter-item"
                                    onClick={(e) => handleClickStatus(e, statusID)}
                                >
                                    <div className="me-2">
                                        <input
                                            type="checkbox"
                                            checked={draftStatus.includes(statusID)}
                                            onChange={() => null}
                                            className="form-check-input"
                                        />
                                    </div>

                                    <Badge className="fs-12" bg={statusID === 0 ? 'success' : 'secondary'}>
                                        {t(`status.${statusID}`)}
                                    </Badge>
                                </button>
                            ))}
                        </div>
                        <div className="p-3 offcanvas-footer off-filter-footer">
                            <div className="d-flex justify-content-end gap-2">
                                <Button variant="secondary" onClick={handleReset}>
                                    {t('common:buttons.reset')}
                                </Button>
                                <Button variant="info" className="min100px" onClick={handleApply}>
                                    {t('common:buttons.apply')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default ClientFilterStatus;
